import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { OrderExchangeRatesResponse } from 'src/app/shared/models/OrderExchangeRatesResponse.model';
import { DistributionReqRes } from 'src/app/dashboard/shared/holding/distribution/DistributionReqRes.model';
import { HttpService } from '../http.service';
import { LoggerService } from 'src/app/shared/errors/logger.service';
import { ClientBankAccountReqRes, ClientBankAccountResponseBasic } from 'src/app/dashboard/models/bankAccount.model';
import { SearchOptionsRequest } from 'src/app/shared/models/SearchOptionsRequest.model';
import { SearchOptionsResponse } from 'src/app/shared/models/SearchOptionsResponse.model';
import { AbstractRestService } from 'src/app/shared/types/AbstractRestService';
import { MergeUnitClientBankAccountDto } from 'src/app/shared/models/MergeUnitClientBankAccountDto.model';
import { LpHoldingBankAccountPreferenceReqRes } from 'src/app/lp/lp-bank-accounts/LpHoldingBankAccountPreferenceReqRes.model';

@Injectable()
export class LpBankAccountDataService extends AbstractRestService<ClientBankAccountReqRes, ClientBankAccountResponseBasic>{
  protected readonly baseEndpoint$ = of('lp/bank-account/');

  public readonly LP_HOLDINGS_BASE_ENDPOINT = 'lp/bank-account';

  constructor(http: HttpService, private loggerService: LoggerService) {
    super(http);
   }

  /** Get the bank account preferences for all holdings */
  getAllHoldingBankAccountPreferences() {
    const url = `${this.LP_HOLDINGS_BASE_ENDPOINT}/bank-accounts-with-holdings`;
    return this.http.getTyped<LpHoldingBankAccountPreferenceReqRes[]>(url).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  createOrUpdateBankAccount(model: ClientBankAccountReqRes) {
    const url = `${this.LP_HOLDINGS_BASE_ENDPOINT}`;
    return this.http.putTyped<ClientBankAccountReqRes>(url, model).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getAllBankAccountsTable(searchOptions: SearchOptionsRequest = null) : Observable<SearchOptionsResponse<MergeUnitClientBankAccountDto>>{
    const queryParams = this.getSearchOptionsToQuerystring(searchOptions);
    return this.baseEndpoint$.pipe(
      switchMap(base => this.http.getTyped<SearchOptionsResponse<MergeUnitClientBankAccountDto>>(`${base}table${queryParams}`)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getAllBankAccounts() : Observable<MergeUnitClientBankAccountDto[]>{
    return this.baseEndpoint$.pipe(
      switchMap(base => this.http.getTyped<MergeUnitClientBankAccountDto[]>(`${base}`)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  setHoldingBakAccount(request:LpHoldingBankAccountPreferenceReqRes): Observable<boolean>{
    return this.baseEndpoint$.pipe(
      switchMap(base => this.http.putTyped<boolean>(`${base}bank-account-holding`, request)),
      catchError(err => {
        return of(false);
      })
    );
  }
}
